import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { FRAGMENT_IMAGE_STYLE } from 'src/graphql/imageStyle';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_VISUAL_LANGUAGE } from './schema';

const QUERY = gql`
  query WorkspaceVisualLanguages($customerId: ID!, $id: ID) {
    workspaces(customerId: $customerId, id: $id) {
      edges {
        node {
          id
          visualLanguages {
            ...VisualLanguage

            imageStyles {
              ...ImageStyle
            }
          }
          defaultVisualLanguage {
            id
          }
        }
      }
    }
  }
  ${FRAGMENT_VISUAL_LANGUAGE}
  ${FRAGMENT_IMAGE_STYLE}
`;

export const queryWorkspaceVisualLanguagesWithAssets = async (
  { customerId, workspaceId },
  options
) => {
  const variables = { customerId, id: workspaceId };

  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  const data = getSingleProp(result.data);
  const workspace = data?.edges[0]?.node;
  return {
    visualLanguages: workspace?.visualLanguages || [],
    defaultVisualLanguageId: workspace?.defaultVisualLanguage?.id || null,
  };
};
